import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-closefull",
  "use": "icon-closefull-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-closefull\"><path d=\"M1024 752.938667v60.245333h-210.816V1024h-60.245333v-271.061333H1024zM271.061333 0v271.061333H0V210.773333h210.816V0h60.245333z\" fill=\"#111111\" p-id=\"7706\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol